module.exports = __webpack_public_path__ + "static/media/category1.7acc1b92.png";